import React from 'react';
import styled from 'styled-components';
import {
  color, typography, layout, space, border,
} from 'styled-system';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const SText = styled.div(
  {
    display: 'inline-block',
  },
  color,
  typography,
  layout,
  space,
  border,
);
SText.defaultProps = {
  fontSize: 14,
};

export default function Text({ translationId, children, ...rest }) {
  return (
    <SText {...rest}>
      { translationId ? <FormattedMessage id={translationId} /> : null}
      { children }
    </SText>
  );
}

Text.propTypes = {
  translationId: PropTypes.string,
  children: PropTypes.node,
};

Text.defaultProps = {
  translationId: null,
  children: '',
};
